import React from "react";
import { addDays, format, isSameDay, startOfWeek } from "date-fns";
import { ListTodo, Plus } from "lucide-react";
import { schApi } from "@/lib/schApi";
import TaskRow from "@/components/nds/windows/sch/TaskRow";

const ymd = (d) => format(d, "yyyy-MM-dd");

/** Day tasks above the day/week grid: a full list in day view, one column per day in week view; overdue open tasks show on today. */
export default function TasksBar({ view, anchor, data, names, onChanged, onAdd, onEdit }) {
  if (!data || view === "month") return null;
  const { tasks, overdue, today } = data;
  const days = view === "week" ? Array.from({ length: 7 }, (_, i) => addDays(startOfWeek(anchor), i)) : [anchor];
  const forDay = (d) => [...(ymd(d) === today ? overdue : []), ...tasks.filter((t) => t.date === ymd(d))];
  const row = (t, compact) => <TaskRow key={t.id} task={t} api={schApi} base="/tasks" names={names} manage compact={compact} today={today} onChanged={onChanged} onEdit={onEdit} />;
  const total = days.reduce((n, d) => n + forDay(d).length, 0);
  return (
    <div data-testid="sch-tasks-bar" className="border-b border-white/10 bg-white/[0.015]">
      <div className="flex items-center gap-2 px-3 pt-2 font-mono text-[10px] tracking-[0.2em] uppercase text-nex-muted">
        <ListTodo className="h-3.5 w-3.5 text-nex-gold" /> To-do · {total}
        {overdue.length > 0 && <span data-testid="sch-tasks-overdue-count" className="text-amber-300">· {overdue.length} overdue</span>}
      </div>
      {view === "day" ? (
        <div className="p-3 pt-2 space-y-1" data-testid={`sch-tasks-day-${ymd(anchor)}`}>
          {forDay(anchor).map((t) => row(t, false))}
          <button type="button" onClick={() => onAdd(ymd(anchor))} data-testid="sch-tasks-add-day" className="inline-flex items-center gap-1 text-[11px] text-nex-muted hover:text-nex-gold"><Plus className="h-3 w-3" /> Add task</button>
        </div>
      ) : (
        <div className="grid" style={{ gridTemplateColumns: "52px repeat(7, 1fr)" }}>
          <div />
          {days.map((d) => (
            <div key={ymd(d)} data-testid={`sch-tasks-day-${ymd(d)}`} className={`border-l border-white/10 p-1 space-y-1 min-h-[44px] max-h-44 overflow-y-auto ${isSameDay(d, new Date()) ? "bg-nex-gold/[0.04]" : ""}`}>
              {forDay(d).map((t) => row(t, true))}
              <button type="button" onClick={() => onAdd(ymd(d))} data-testid={`sch-tasks-add-${ymd(d)}`} className="w-full inline-flex items-center gap-1 text-[10px] text-nex-muted hover:text-nex-gold px-1"><Plus className="h-3 w-3" /> task</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
